<nav
  [@animateMenu]
  class="navbar main-navbar on-top"
  [class.nav-shadow]="this.pageYPosition > 0"
>
  <div class="container">
    <a class="navbar-brand text-light" [routerLink]="'inicio'">
      <img src="assets/images/me/logo-light.svg" width="50" />
    </a>
    <ul ngbNav #nav="ngbNav" class="menu-ul">
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('about')"
          ><span class="nav-number">01.</span>
          <span class="underline nav-text">
            {{ "Header.Item1" | translate }}</span
          ></a
        >
        <ng-template ngbNavContent>First content</ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('jobs')"
          ><span class="nav-number">02.</span>
          <span class="underline nav-text">
            {{ "Header.Item2" | translate }}</span
          ></a
        >
        <ng-template ngbNavContent>Second content</ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('projects')"
          ><span class="nav-number">03.</span>
          <span class="underline nav-text">
            {{ "Header.Item3" | translate }}</span
          ></a
        >
        <ng-template ngbNavContent>Second content</ng-template>
      </li>
      <li ngbNavItem>
        <a ngbNavLink (click)="scroll('contact')"
          ><span class="nav-number">04.</span>
          <span class="underline nav-text">
            {{ "Header.Item4" | translate }}</span
          ></a
        >
        <ng-template ngbNavContent>Second content</ng-template>
      </li>
      <li ngbNavItem>
        <a (click)="downloadCV()" class="main-btn cv-btn" ngbNavLink>
          {{ "Header.cvBtn" | translate }}
        </a>
      </li>
    </ul>
    <div
      class="menu-wrapper"
      (click)="responsiveMenuVisible = !responsiveMenuVisible"
    >
      <div [class.animate]="responsiveMenuVisible" class="hamburger-menu"></div>
    </div>
    <div class="menu-responsive" [class.show]="responsiveMenuVisible">
      <aside
        [class.aside-show]="responsiveMenuVisible"
        [class.nav-shadow]="this.pageYPosition > 0"
        class="on-top"
      >
        <nav>
          <ol>
            <li>
              <a (click)="scroll('about')">
                <span></span> {{ "Header.Item1" | translate }}
              </a>
            </li>
            <li>
              <a (click)="scroll('jobs')">
                <span></span> {{ "Header.Item2" | translate }}
              </a>
            </li>
            <li>
              <a (click)="scroll('projects')">
                <span></span> {{ "Header.Item3" | translate }}
              </a>
            </li>
            <li>
              <a (click)="scroll('projects')">
                <span></span> {{ "Header.Item4" | translate }}
              </a>
            </li>
            <li>
              <a (click)="downloadCV()" class="main-btn cv-btn">
                {{ "Header.cvBtn" | translate }}
              </a>
            </li>
          </ol>
        </nav>
      </aside>
    </div>
  </div>
</nav>
